import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllActiveResults = createAsyncThunk(
    'winner/getAllActiveResults',
    async ({ draw_date, draw_no, skip, limit }, { rejectWithValue }) => {
        try {            
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params: {
                    ...(draw_date ? { draw_date } : {}),
                    ...(draw_no ? { draw_no } : {}),
                    ...(skip ? { skip: skip - 1 } : {}),
                    ...(limit ? { limit } : {}),
                },
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/lottery-results`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);
